import configureStore from "./configureStore"
import ReactReduxConnect from "./connect"

export const store = configureStore()
export {ReactReduxConnect as connect}
